export const IS_DEVELOPMENT = false;

export const PREFIX_URL = IS_DEVELOPMENT ? '/' : '/pmm/';
